export enum MessageEventType{
  Read,
  Updated
}
